/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AlertsManager {
    'use strict';

    interface IAlertsManagerController {
        closeContext: () => void;
    }

    class AlertsManagerController implements IAlertsManagerController {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected alertsManagerService: IAlertsManagerService
        ) {
            alertsManagerService.alert = null;
            alertsManagerService.view = ViewEnum.List;
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        get viewEnum(): any {
            return ViewEnum;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .controller('meevo.plugins.alertsManager.AlertsManagerController', AlertsManagerController);
}